export default __webpack_public_path__ + "static/rings-9773fd8245b433b5b61b4baab7ec8213.png";